import React, { useState } from 'react';
import PropTypes from 'prop-types';


const ItineraryPlanOption = ({
  finalConfirm,
  planOptions, 
  SP, 
  questionAndAnswers = null, 
  onQuestionAnswerChange = null,
}) => {

  // 回答が入力されたらstateを更新
  const handleQuestionAnswerChange = (itineraryIndex, questionIndex, value) => {
    if (onQuestionAnswerChange) {
      onQuestionAnswerChange(itineraryIndex, questionIndex, value);
    }
  };

  if(!planOptions || planOptions.length === 0) {
    return null;
  }

  return planOptions.map((planOption) => {

    const {
      itineraryIndex,
      goods,
      peopleCounts,
    } = planOption;

    const [isOpen, setIsOpen] = useState(false);
    const goodsDetailInfo = !finalConfirm ? goods.goodsDetailInfo : goods;
    const goodsBasicInfo = !finalConfirm ? goods.goodsBasicInfo : goods;
    const noticeAndGuidance = !finalConfirm ? goods.noticeAndGuidance : goods;
    const totalCount = Object.entries(peopleCounts)
    .filter(([key]) => key !== "DATE" && key !== "chargesList" && !/Price$/.test(key))
    .reduce((sum, [, value]) => sum + Number(value), 0);
    const questions = !finalConfirm ? goods.facilityQuestions : goods.questions;
 
    return (
      <React.Fragment key={itineraryIndex}>
        <div className={!SP ? 'itinerary' : 'UserInfo'}>
          {!SP && (
            <div className="itineraryTitle">タビサキMenu</div>
          )}
          <div className={!SP ? 'itineraryScheduleContainer' : 'UserInfoItineraryScheduleContainer'}>
            <div className="title">{goodsDetailInfo.categoryDetail}</div>
            <div className="subTitle">{goods.landFacilityName} {goods.goodsName} {goods.goodsPlanName}</div>
            <div className="totalCount">{totalCount}{goodsDetailInfo.displayUnit}</div>
            {(goodsBasicInfo.planExplanationDetail || noticeAndGuidance.noticeAndOthers) && <div className="planExplanationDetail" onClick={() => setIsOpen(!isOpen)}>
              <span className="title">ご案内ご注意・プラン詳細</span>
              <div className={`content ${isOpen ? 'isOpen' : 'isClose'}`}>
                <p dangerouslySetInnerHTML={{ __html: noticeAndGuidance.noticeAndOthers }}></p>
                <p dangerouslySetInnerHTML={{ __html: goodsBasicInfo.planExplanationDetail }} />
              </div>
            </div>}

            {questions && questions.length > 0 && (
            <div className="itineraryQuestions">
              {
                questions.map((question, i) => (
                  <div key={i} className="itineraryQuestion">
                    <div className="itineraryQuestionTitle">
                      <p className="title">施設からの質問</p>
                      <p className="content" dangerouslySetInnerHTML={{ __html: finalConfirm ? question.question : question.content }} />
                    </div>
                    <div className="itineraryQuestionAnswer">
                      <div className="itineraryQuestionAnswerTitle">
                        <p className="title">ユーザー回答</p>
                        {!finalConfirm ? ((question.required || question.isUserAnswerNeeded) ? <span className="requierd">※必須</span> : <span>※任意</span>) : ''}
                      </div>
                      {finalConfirm ? (
                      <div 
                        className="itineraryQuestionAnswerTextarea"
                        style={{ whiteSpace: 'pre-wrap' }}
                      >
                        {question.answer || '回答なし'}
                      </div>
                    ) : (
                      <textarea 
                        className="itineraryQuestionAnswerTextarea"
                        id={finalConfirm ? '' : `${itineraryIndex}-${goods.goodsCode}-q${i}`} 
                        placeholder="回答を入力してください"
                        rows={3} 
                        value={finalConfirm ? (question.answer || '') : (() => {
                          if (!questionAndAnswers) {
                            return '';
                          }
                          const questionData = questionAndAnswers[itineraryIndex];
                          if (!questionData || !questionData.facilityQuestions || !questionData.facilityQuestions[i]) {
                            return '';
                          }
                          return questionData.facilityQuestions[i].answer || '';
                        })()}
                        onChange={(e) => handleQuestionAnswerChange(itineraryIndex, i, e.target.value)}
                        disabled={finalConfirm}
                      />
                    )}
                    </div>
                  </div>
                ))
              }
            </div>
          )}

          </div>
        </div>
      </React.Fragment>
    );
  });

};

ItineraryPlanOption.defaultProps = {
  finalConfirm: false,
  SP: false,
  onQuestionAnswerChange: null,
};

ItineraryPlanOption.propTypes = {
  finalConfirm: PropTypes.bool,
  planOptions: PropTypes.array,
  SP: PropTypes.bool,
  hideCheckin: PropTypes.bool,
  hideMessage: PropTypes.bool,
  handleUpdateCheckin: PropTypes.func.isRequired,
  showQuestions: PropTypes.bool,
  handleUpdateQuestion: PropTypes.func.isRequired,
  questionAndAnswers: PropTypes.array,
  onQuestionAnswerChange: PropTypes.func,
};

export default ItineraryPlanOption;
